import { WeekRangeObj } from "@/components/Search/types";

function getWeekRangeTitle(weeksToCompleteRange: WeekRangeObj) {
  if (
    !weeksToCompleteRange ||
    weeksToCompleteRange.startWeek == null ||
    weeksToCompleteRange.endWeek == null
  ) {
    return "";
  }

  const maxWeeks = weeksToCompleteRange.endWeek;
  const minWeeks = weeksToCompleteRange.startWeek;

  if (
    !Number.isInteger(minWeeks) ||
    !Number.isInteger(maxWeeks) ||
    minWeeks < 0 ||
    maxWeeks < 0 ||
    minWeeks > maxWeeks
  ) {
    return "";
  }

  return `Learn something new in ${minWeeks}-${maxWeeks} weeks`;
}

export default getWeekRangeTitle;
